import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import {TranslateService} from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { WordcountService } from '../../../../wordcount.service';
import { CKEditor4 } from 'ckeditor4-angular';
import { ModalService } from '../../../../modal.service';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.html',
  styleUrls: ['./tab.scss']
})

export class Tab implements OnInit {

  public forceSelection = false;
  public shownTabs:string[] = [];
  public shownTabIndexes:number[] = [];
  public tabHeaderContent:string[] = [];
  public tabContent:string[] = [];
  public tabAnswers:string[] = [];
  public selectedTab:string = "";
  public activeTabIndex:number = 1;
  public ckeConfig:any;

  private loadAnswersSubscription : Subscription;

  
  constructor(
    public dataSvc: DataService,
    public translate: TranslateService,
    public wordCount: WordcountService,
    public modalService: ModalService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    this.ckeConfig = {
      toolbarGroups: [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
      ],
      // Each tab answer is stored as an HTML fragment inside the one Selection field.
      // Full-page documents cannot be nested safely when several tab answers exist.
      fullPage : false,
      allowedContent: true,
      removeFormatAttributes :'',
      resize_enabled : false,
      resizable: false
    };

    this.ckeConfig.removeButtons = 'Styles,Format,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Redo,Find,Undo,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Link,Unlink,Anchor,Table,Flash,Image,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,ExportPdf';

    this.loadAnswersSubscription = this.dataSvc.getLoadTabAnswersEvent().subscribe(()=>{
      this.loadAnswers();

    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  resetVariables(){
    this.forceSelection = false;
    this.shownTabs = [];
    this.shownTabIndexes = [];
    this.tabHeaderContent = [];
    this.tabContent = [];
    this.tabAnswers = [];
    this.selectedTab = "";
    this.activeTabIndex = 1;
       
  }

  loadAnswers() {
    if(this.dataSvc.currentQuestion.Question.QuestionType !== 1024) return;

    this.resetVariables();
    //GET QUESTION METADATA FOR TABS - THATS WHERE THE INFO FROM ENETASSESS QUESTION BUILDER IS SET
    //ITS LOTS OF SPLITTING AND INDEXOF BUT DONT WANT TO HAVE TO REDO THE WAY QUESTIONS ARE CREATED
    var tabQuestion = this.dataSvc.currentQuestion.Question;
    if(tabQuestion !== null && tabQuestion !== undefined){

          if (this.dataSvc.currentQuestion.Question.Question.WordCount !== null && this.dataSvc.currentQuestion.Question.Question.WordCount !== undefined
          && this.dataSvc.currentQuestion.Question.Question.WordCount > 0) {
          this.wordCount.wordcount = this.dataSvc.currentQuestion.Question.Question.WordCount;
          // setInterval(()=>{
          //   this.wordCount.userWords = this.dataSvc.countAnswersWords();
          // },1000);
        }
      var selection = this.dataSvc.currentQuestion.Result.Selection || "";
      var tabData = (tabQuestion.Question.Metadata || "").toString();
      var chosenTabIndex = this.getChosenTabIndex(tabData, selection);

      if(chosenTabIndex !== null && tabData.indexOf("_ChosenTab=") === -1){
        this.dataSvc.currentQuestion.Question.Question.Metadata += "_ChosenTab=li" + chosenTabIndex + "_";
        tabData = this.dataSvc.currentQuestion.Question.Question.Metadata.toString();
      }

      this.forceSelection = tabData.indexOf("$$$Force$$$") > -1 && chosenTabIndex === null;
      var tabs = tabData.replace("$$$Force$$$", "").split("***");
      for(var i = 1; i < tabs.length; i++){
        var tabInfo = tabs[i].split("||");
        if(tabInfo.length > 1){
          this.tabHeaderContent[i] = tabInfo[0];
          this.tabContent[i] = tabInfo[1];
          if(chosenTabIndex === null || chosenTabIndex === i){
            this.shownTabs.push("li" + i);
            this.shownTabIndexes.push(i);
          }
        }
      }

      if(this.shownTabIndexes.length > 0){
        this.activeTabIndex = chosenTabIndex !== null ? chosenTabIndex : this.shownTabIndexes[0];
      }

      this.loadTabAnswers(selection, chosenTabIndex);
    }
  }

  private getChosenTabIndex(tabData: string, selection: string): number | null {
    var metadataMatch = /_ChosenTab=li(\d+)_/.exec(tabData || "");
    if(metadataMatch){
      return parseInt(metadataMatch[1], 10);
    }

    var selectionMatch = /%%%ChosenTab(\d+)%%%/.exec(selection || "");
    return selectionMatch ? parseInt(selectionMatch[1], 10) : null;
  }

  private loadTabAnswers(selection: string, chosenTabIndex: number | null) {
    if(!selection){
      return;
    }

    var holder = document.createElement("div");
    holder.innerHTML = selection;
    var savedAnswers = holder.querySelectorAll(".enet-tab-answer[data-enet-tab-index]");

    for(var i = 0; i < savedAnswers.length; i++){
      var savedAnswer = savedAnswers[i] as HTMLElement;
      var tabIndex = parseInt(savedAnswer.getAttribute("data-enet-tab-index"), 10);
      var content = savedAnswer.querySelector(".enet-tab-answer-content") as HTMLElement;
      if(!isNaN(tabIndex) && content){
        this.tabAnswers[tabIndex] = content.innerHTML;
      }
    }

    // Existing attempts have one unmarked answer. Keep them editable by assigning
    // that answer to the permanently chosen tab, or the first available tab.
    if(savedAnswers.length === 0){
      var legacyAnswer = selection.replace(/<p[^>]*>%%%ChosenTab\d+%%%<\/p>/i, "").trim();
      var legacyTabIndex = chosenTabIndex !== null ? chosenTabIndex : this.shownTabIndexes[0];
      if(legacyAnswer && legacyTabIndex !== undefined){
        this.tabAnswers[legacyTabIndex] = legacyAnswer;
      }
    }
  }

  updateTabAnswer(tabIndex: number, event: CKEditor4.EventInfo) {
    if(event && event.editor){
      this.tabAnswers[tabIndex] = event.editor.getData();
    }
    this.saveTabAnswers();
    this.wordCount.checkWords(event);
  }

  private saveTabAnswers() {
    var selection = "";
    var chosenTabIndex = this.getChosenTabIndex(
      this.dataSvc.currentQuestion.Question.Question.Metadata || "",
      this.dataSvc.currentQuestion.Result.Selection || ""
    );

    if(chosenTabIndex !== null){
      selection += "<p style='display:none;color:white;background:white;font-size:1px;'>%%%ChosenTab" + chosenTabIndex + "%%%</p>";
    }

    for(var i = 1; i < this.tabAnswers.length; i++){
      var answer = this.tabAnswers[i] || "";
      if(this.isEmptyAnswer(answer)){
        continue;
      }

      selection += "<div class='enet-tab-answer' data-enet-tab-index='" + i + "'>"
        + "<p class='enet-tab-answer-heading'><strong>Answer for: " + this.getTabLabel(i) + "</strong></p>"
        + "<div class='enet-tab-answer-content'>" + answer + "</div>"
        + "</div>";
    }

    this.dataSvc.currentQuestion.Result.Selection = selection;
  }

  private getTabLabel(tabIndex: number): string {
    var holder = document.createElement("div");
    holder.innerHTML = this.tabHeaderContent[tabIndex] || ("Tab " + tabIndex);
    var label = (holder.textContent || holder.innerText || ("Tab " + tabIndex)).trim();
    return label.replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  private isEmptyAnswer(answer: string): boolean {
    var holder = document.createElement("div");
    holder.innerHTML = answer || "";
    return (holder.textContent || "").replace(/\u00a0/g, " ").trim() === "";
  }

  cleanTabContent() { 
    for (var i = 0; i < this.tabContent.length; i++) {

      if(this.tabContent[i].indexOf("_ChosenTab=") > -1){
        var first = this.tabContent[i].indexOf("_ChosenTab=");
        var last = this.tabContent[i].lastIndexOf("_") + 1;
        var tab = this.tabContent[i].substring(first, last)
        this.tabContent[i] = this.tabContent[i].replace(tab, "");//.replace("_ChosenTab=", "").replace("_", "");
      }

      
      this.tabContent[i] = this.tabContent[i].replace("$$$Force$$$", "");
    }
  }

  activateTab(tabIndex: number, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    this.activeTabIndex = tabIndex;
  }

  selectTab(){
    //IF FORCE SELECTION IS ENABLED FOR TAB QUESTION, THIS WILL SELECT THE TAB PERMANENTLY
    var cfmMsg = "";
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      if(exisitingLangauge == "en"){
        cfmMsg = "Are you sure you want to to select this question, you wont be able to change at a later date?";
      }
      else if(exisitingLangauge == "nl"){
        cfmMsg = "Weet u zeker dat u dit tabblad wilt selecteren, u kunt dit later niet wijzigen?";
      }
    }
    else{
      cfmMsg = "Are you sure you want to to select this question, you wont be able to change at a later date?";
    }
    //var cnf = confirm(cfmMsg);
    this.modalService.openConfirmModal(cfmMsg).then(cnf => {
      if(cnf){
        this.selectedTab = "li" + this.activeTabIndex;
        if(this.selectedTab !== ""){
          this.shownTabs.length = 0;
          this.shownTabs.push(this.selectedTab);
          this.shownTabIndexes = [this.activeTabIndex];
          this.dataSvc.currentQuestion.Question.Question.Metadata += "_ChosenTab=" + this.selectedTab + "_";

          if(!this.dataSvc.previewMode){
            this.saveTabAnswers();
          }
          this.forceSelection = false;
        }
      }
    });
  }

}
